import React, { useState, useEffect } from "react";
import { Tabs, Tab, Box, Typography } from "@mui/material";
import NMC from "./nmc";
import MC from "./mc";
import ICON from "./icon";
import VIP from "./vip";
import Total from "./total";
import Collector from "./collector";
import Postponed from "./postponed";
import Inactive from "./inactive";
import BeCollected from "./Becollected";
import Special from "./Special";
import Blacklist from "./blacklist";
import Imad from "./Imad";
import Negative from "./negative";
import Ziad from "./Ziad";
import Bennay from "./Bennay";
import Deirkousheh from "./Deirkousheh";
import "./report.css"; // Import CSS

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function Report() {
  const [value, setValue] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    const updateLayout = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    updateLayout();
    window.addEventListener("resize", updateLayout);
    return () => window.removeEventListener("resize", updateLayout);
  }, []);

  const tabs = [
    "Total",
    "NMC",
    "MC",
    "Blacklist",
    "Special",
    "VIP",
    "Collector",
    "Imad",
    "To Be Collected",
    "Postponed",
    "Inactive",
    "Negative",
    "Icon",
    "Ziad",
    "Bennay",
    "Deirkousheh"
  ];

  return (
    <div className="report">
      <div className="main-content">
        {isMobile ? (
          // Mobile layout
          <div className="tabs-container">
            {tabs.map((tab, index) => (
              <div
                key={index}
                className={`tab-item ${value === index ? "active-tab" : ""}`}
                onClick={() => setValue(index)}
              >
                {tab}
              </div>
            ))}
          </div>
        ) : (
          // Laptop/Tablet layout with Material-UI Tabs
          <Box sx={{ width: "100%", borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="responsive tabs"
              textColor="inherit"
              variant="scrollable"
              scrollButtons="auto"
              TabIndicatorProps={{ style: { backgroundColor: "white" } }}
            >
              {tabs.map((tab, index) => (
                <Tab
                  key={index}
                  label={tab}
                  {...a11yProps(index)}
                  sx={{ color: "white", minWidth: "fit-content" }}
                />
              ))}
            </Tabs>
          </Box>
        )}

        {/* Tab Panels */}
        <TabPanel value={value} index={0}><Total /></TabPanel>
        <TabPanel value={value} index={1}><NMC /></TabPanel>
        <TabPanel value={value} index={2}><MC /></TabPanel>
        <TabPanel value={value} index={3}><Blacklist /></TabPanel>
        <TabPanel value={value} index={4}><Special /></TabPanel>
        <TabPanel value={value} index={5}><VIP /></TabPanel>
        <TabPanel value={value} index={6}><Collector /></TabPanel>
        <TabPanel value={value} index={7}><Imad /></TabPanel>
        <TabPanel value={value} index={8}><BeCollected /></TabPanel>
        <TabPanel value={value} index={9}><Postponed /></TabPanel>
        <TabPanel value={value} index={10}><Inactive /></TabPanel>
        <TabPanel value={value} index={11}><Negative /></TabPanel>
        <TabPanel value={value} index={12}><ICON /></TabPanel>
        <TabPanel value={value} index={13}><Ziad /></TabPanel>
        <TabPanel value={value} index={14}><Bennay /></TabPanel>
        <TabPanel value={value} index={15}><Deirkousheh /></TabPanel>
      </div>
    </div>
  );
}

export default Report;
